import { createFileRoute } from '@tanstack/react-router';

import { LibraryHealthPage } from '@/areas/risk-management/LibraryHealth/LibraryHealthPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/risk-management/library-health/')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <LibraryHealthPage />;
}
